// import { ROUTES } from "../utils/viewUtility";

export const routes = {
  HOME: "/",
  LOGIN: "/login",
  PROFILE: "/profile",
  HOP: "/hop",
  SERVICE_REQUEST: "/serviceRequest",
  SERVICE_REQUEST_DETAILS: "/serviceRequest/details",
  SERVICE_REQUEST_CUSTOMER_DETAILS: "/serviceRequest/customer-details",
  CREATE_SERVICE_REQUEST: "/serviceRequest/createServiceRequest"
};

export default routes;

export const rerouteAfterLoginRoutes = [routes.HOP];
